import React from 'react'
import {
    Checkbox,
    CircularProgress,
} from '@mui/material'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import CustomTable from '../table/table'
import './item-selection-modal.scss'
import { numberFormat, toUSD } from '../../util/currency-formatter'
import { isInlineItem, INLINE_CATALOG_DISPLAY_NAME } from '../../util/common'

const ItemSelectionModal = (props) => {
    const {
        open,
        onClose,
        onAddItems,
        onSelectItem,
        items = [],
        selectedItemIds = [],
        isLoading
    } = props;

    const renderCheckbox = (item) => {
        const itemId = `${item.id}_${item.cost || item.price || 0}_${item.taskId || ""}`;
        return (
            <Checkbox
                checked={selectedItemIds.includes(itemId)}
                onClick={(e) => {
                    e.stopPropagation();
                    onSelectItem(itemId);
                }}
                onMouseDown={(e) => e.stopPropagation()}
                onMouseUp={(e) => e.stopPropagation()}
                className="item-selection-modal-checkbox"
                size="small"
            />
        );
    };

    const renderCatalog = (item) => {
        if (isInlineItem(item)) return INLINE_CATALOG_DISPLAY_NAME;
        return item.category && item.category.name ? item.category.name : '';
    };

    const renderPartNumber = (item) => {
        return item.partNo || item.part_no || '';
    };

    const renderCost = (item) => {
        return toUSD(item.cost)
    }

    const renderQty = (item) => {
        return numberFormat(item.qty || 0, true);
    }

    const columns = [
        {
            field: 'select',
            title: '',
            render: renderCheckbox,
            class: 'item-selection-modal-checkbox-column'
        },
        {
            field: 'category',
            title: 'Catalog',
            render: renderCatalog,
            class: 'item-selection-modal-catalog-column'
        },
        {
            field: 'manufacturer',
            title: 'Category',
            class: 'item-selection-modal-manufacturer-column'
        },
        {
            field: 'partNo',
            title: 'Part No',
            render: renderPartNumber,
            class: 'item-selection-modal-part-column'
        },
        {
            field: 'item',
            title: 'Item Description',
            class: 'item-selection-modal-item-column'
        },


        {
            field: 'cost',
            title: 'Cost($)',
            render: renderCost,
            class: 'item-selection-modal-cost-column text-right'
        },
        {
            field: 'qty',
            title: 'Quantity',
            render: renderQty,
            class: 'item-selection-modal-cost-column text-right'
        }
    ];

    const tableItemClickHandler = (item) => {
        if (item && item.id) {
            const itemId = `${item.id}_${item.cost || item.price || 0}_${item.taskId || ""}`;
            onSelectItem(itemId);
        }
    };

    return (
        <Modal
            show={open}
            onHide={onClose}
            dialogClassName="modal-80w mt-5 create-modal"
            aria-labelledby="example-custom-modal-styling-title item-selection-dialog-title"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">
                    SELECT ITEMS
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="item-selection-modal-content">
                <div className="item-selection-modal-content-wrapper">
                    {isLoading ? (
                        <div className="item-selection-modal-loading-container">
                            <CircularProgress size={48} thickness={4} className="item-selection-modal-loading-container-progress" />
                            <p className="item-selection-modal-loading-container-text">Loading inventory items...</p>
                        </div>
                    ) : (
                        <>
                            {items.length > 0 ? (
                                <div className="item-selection-modal-table-container">
                                    <div className="item-selection-modal-table-wrapper">
                                        <CustomTable
                                            columns={columns}
                                            data={items}
                                            toolbar={true}
                                            exportButton={false}
                                            rowClickHandler={tableItemClickHandler}
                                            className="item-selection-modal-custom-table"
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className="item-selection-modal-empty-state">
                                    <p className="item-selection-modal-empty-state-text">
                                        No items available
                                    </p>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </Modal.Body>

            <Modal.Footer className="item-selection-modal-actions">
                <Button
                    onClick={onClose}
                    className="secondarybtn cancelbtn ms-auto"
                    data-cy="cancel-button"
                >
                    CANCEL
                </Button>
                <Button
                    onClick={onAddItems}
                    disabled={selectedItemIds.length === 0}
                    className="btn-bg-brand-3"
                    data-cy="add-selected-items-button"
                >
                    ADD SELECTED ITEMS ({selectedItemIds.length})
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ItemSelectionModal;